import { LoadingOutlined } from '@ant-design/icons';
import Button from './Button';
import ExportIcon from 'components/Icons/ExportIcon';

interface Iprops {
  title?: string;
  onClick: any;
  disabled?: boolean;
  loading?: boolean;
}

const ButtonExport = ({
  title = 'Export',
  onClick,
  disabled = false,
  loading = false,
}: Iprops) => {
  return (
    <Button
      title={loading ? 'Đang xuất...' : title}
      disabled={disabled}
      loading={loading}
      handleOnclick={onClick}
      iconBefore={
        loading ? (
          <LoadingOutlined style={{ fontSize: '16px' }} spin />
        ) : (
          <ExportIcon />
        )
      }
    />
  );
};

export default ButtonExport;
